__turbopack_context__.v({
  "thumbnail": "VideoEmbed-module-scss-module__NJa8MG__thumbnail",
  "videocontainer": "VideoEmbed-module-scss-module__NJa8MG__videocontainer",
  "videoinnercontainer": "VideoEmbed-module-scss-module__NJa8MG__videoinnercontainer",
});
